module.exports = __webpack_public_path__ + "static/media/pattern_footer.611310ed.png";